import React, { Component } from "react";
import images from "./ImageHelper";

class Skills extends Component {
  render() {
    return (
      <>
        <header className="header">
          <h2 id="skills">Skills</h2>
        </header>

        <div className="skills-container">
          <ul className="col">
            <h5 className="row">Frontend</h5>

            <h6 className="row">
              <a href="https://en.wikipedia.org/wiki/HTML5">
                <img className="logo" src={images.html} alt="html5 logo" />
                <li className="skill">HTML/CSS</li>
              </a>
            </h6>

            <h6 className="row">
              <a href="https://en.wikipedia.org/wiki/JavaScript">
                <img
                  className="logo"
                  src={images.javascript}
                  alt="javascript logo"
                />
                <li className="skill">Javascript</li>
              </a>
            </h6>

            <h6 className="row">
              <a href="https://en.wikipedia.org/wiki/React_(web_framework)">
                <img className="logo" src={images.react} alt="react.js logo" />
                <li className="skill">React.js</li>
              </a>
            </h6>

            <h6 className="row">
              <a href="https://en.wikipedia.org/wiki/Vue.js">
                <img className="logo" src={images.vue} alt="vue.js logo" />
                <li className="skill">Vue.js</li>
              </a>
            </h6>

            <h6 className="row">
              <a href="https://en.wikipedia.org/wiki/TypeScript">
                <img
                  className="logo"
                  src={images.typescript}
                  alt="typescript logo"
                />
                <li className="skill">TypeScript</li>
              </a>
            </h6>
          </ul>

          <ul className="col">
            <h5 className="row">Backend</h5>

            <h6 className="row">
              <a href="https://en.wikipedia.org/wiki/Python_(programming_language)">
                <img className="logo" src={images.python} alt="python logo" />
                <li className="skill">Python</li>
              </a>
            </h6>

            <h6 className="row">
              <a href="https://en.wikipedia.org/wiki/Flask_(web_framework)">
                <img className="logo" src={images.flask} alt="flask logo" />
                <li className="skill">Flask</li>
              </a>
            </h6>

            <h6 className="row">
              <a href="https://en.wikipedia.org/wiki/MongoDB">
                <img className="logo" src={images.mongo} alt="mongodb logo" />
                <li className="skill">MongoDB</li>
              </a>
            </h6>
          </ul>

          <ul className="col">
            <h5 className="row">Tools</h5>

            <h6 className="row">
              <a href="https://en.wikipedia.org/wiki/Docker_%28software%29">
                <img className="logo" src={images.docker} alt="docker logo" />
                <li className="skill">Docker</li>
              </a>
            </h6>

            <h6 className="row">
              <a href="https://en.wikipedia.org/wiki/Git">
                <img className="logo" src={images.git} alt="git logo" />
                <li className="skill">Git</li>
              </a>
            </h6>

            <h6 className="row">
              <a href="https://en.wikipedia.org/wiki/GitHub">
                <img className="logo" src={images.github} alt="github logo" />
                <li className="skill">GitHub</li>
              </a>
            </h6>

            <h6 className="row">
              <a href="https://en.wikipedia.org/wiki/Visual_Studio_Code">
                <img className="logo" src={images.vscode} alt="vscode logo" />
                <li className="skill">VS Code</li>
              </a>
            </h6>
          </ul>

          <ul className="col">
            <h5 className="row">Workflow</h5>

            <h6 className="row">
              <a href="https://en.wikipedia.org/wiki/Slack_(software)">
                <img
                  className="logo"
                  id="slack"
                  src={images.slack}
                  alt="slack logo"
                />
                <li className="skill">Slack</li>
              </a>
            </h6>

            <h6 className="row">
              <a href="https://en.wikipedia.org/wiki/Trello">
                <img className="logo" src={images.trello} alt="trello logo" />
                <li className="skill">Trello</li>
              </a>
            </h6>

            <h6 className="row" id="azure-row">
              <a href="https://en.wikipedia.org/wiki/Azure_DevOps_Server">
                <img
                  className="logo"
                  src={images.azure_devops}
                  alt="azure devops logo"
                />
                <li className="skill">Azure DevOps</li>
              </a>
            </h6>
          </ul>

          <ul className="col">
            <h5 className="row">ML</h5>

             <h6 className="row">
              <a href="https://en.wikipedia.org/wiki/Claude_(AI)">
                <img className="logo" src={images.claude} alt="claude logo" />
                <li className="skill">Claude</li>
              </a>
            </h6>

            {/* <h6 className="row">
              <a href="https://en.wikipedia.org/wiki/PyTorch">
                <img className="logo" src={images.pytorch} alt="pytorch logo" />
                <li className="skill">PyTorch</li>
              </a>
            </h6>

            <h6 className="row">
              <a href="https://en.wikipedia.org/wiki/NumPy">
                <img className="logo" src={images.numpy} alt="numpy logo" />
                <li className="skill">NumPy</li>
              </a>
            </h6>

            <h6 className="row">
              <a href="https://en.wikipedia.org/wiki/Pandas_(software)">
                <img className="logo" src={images.pandas} alt="pandas logo" />
                <li className="skill">Pandas</li>
              </a>
            </h6> */}
          </ul>
        </div>
      </>
    );
  }
}

export default Skills;
